import React from 'react';
import Skeleton from 'react-loading-skeleton';

export default class StorefrontEditorEasyblocksSkeleton extends React.PureComponent {
  render() {
    return (
      <div className="storefront-editor--easyblocks-skeleton">
        <div className="storefront-editor--easyblocks-skeleton--container">
          <Skeleton
            containerClassName="storefront-editor--easyblocks-skeleton--header"
            height={40}
            width={220}
          />
          <Skeleton
            containerClassName="storefront-editor--easyblocks-skeleton--banner"
            height={250}
          />
          <Skeleton
            containerClassName="storefront-editor--easyblocks-skeleton--content"
            count={3}
            height={100}
          />
        </div>
      </div>
    );
  }
}
